import type { AutocompletionRequest } from "../types";

export default (
  autocompletionRequest: AutocompletionRequest,
  input: string,
  sessionToken?: google.maps.places.AutocompleteSessionToken | false
): google.maps.places.AutocompleteRequest => {
  const { bounds, location, offset, componentRestrictions, types } = autocompletionRequest;

  const res: google.maps.places.AutocompleteRequest = { input };

  if (sessionToken) {
    res.sessionToken = sessionToken;
  }

  if (bounds) {
    res.locationBias = new google.maps.LatLngBounds(...bounds);
  } else if (location) {
    res.locationBias = new google.maps.LatLng(location);
  }

  if (offset !== undefined) {
    res.inputOffset = offset;
  }

  if (componentRestrictions?.country) {
    const countries = Array.isArray(componentRestrictions.country)
      ? componentRestrictions.country
      : [componentRestrictions.country];
    res.includedRegionCodes = countries;
  }

  if (types?.length) {
    res.includedPrimaryTypes = types;
  }

  return res;
};
